import { Tooltip } from "@mui/material";
import { navbarHeight } from "./navbar";

import esp from '../assets/icons/flags/ESP.svg';
import cat from '../assets/icons/flags/AND.svg';
import eng from '../assets/icons/flags/GB-UKM.svg';

export default function LanguageSwitcher({onChange=(lang)=>{}}) {
    return <div style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '5px',
    }}>
        <Tooltip title={'ESPAÑOL'} sx={{zIndex: 10}}><div onClick={() => {onChange('es')}} className="flag"><img src={esp} alt="ESPAÑOL"/></div></Tooltip>
        <Tooltip title={'CATALÀ'} sx={{zIndex: 10}}><div onClick={() => {onChange('ca')}} className="flag"><img src={cat} alt="CATALÀ"/></div></Tooltip>
        <Tooltip title={'ENGLISH'} sx={{zIndex: 10}}><div onClick={() => {onChange('en')}} className="flag"><img src={eng} alt="ENGLISH"/></div></Tooltip>
    </div>
}